import React, { useEffect } from 'react';
import AddCoordinatePhoto from '../images/CoordinateAdd.png';
import EditCoordinatePhoto from '../images/CoordinateEdit.png';
import styled from 'styled-components';

const StyledContainer = styled.div`
width: 100%;
margin: auto;
padding: 10px 0px 10px 0px;
`;

const CoordinatePage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ fontSize: "18px" }}>
        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Coordinate System
        </div>
        <div style={{ marginTop: '10px' }}>
        For every project, the first step is to set a local coordinate system. To do it, enter the geo-coordinates for the local coordinate system's origin. 
        Any other objects added to the project later will be relative to the origin in the local coordinate system.
        </div>
        <div style={{ marginTop: '10px' }}>
        To add a local coordinate system, right click Project node, click <strong>Add Coordinate Origin</strong> menu. 
        In <strong>Add Coordinate Origin</strong> dialog, enter coordinate values, and click <strong>OK</strong>.
        </div>

        <StyledContainer>
            <img src={AddCoordinatePhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ marginTop: '10px' }}>
        To edit local coordinate system, right click Coordinate node, click <strong>Edit Coordinate Origin</strong> menu. 
        In <strong>Edit Coordinate Origin</strong> dialog, change coordinate values, and click <strong>OK</strong>.
        </div>
        <StyledContainer>
            <img src={EditCoordinatePhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>
    </div>
  )
}

export default CoordinatePage;